import { render, staticRenderFns } from "./VestingSelect.vue?vue&type=template&id=71d0a68e&"
import script from "./VestingSelect.vue?vue&type=script&lang=js&"
export * from "./VestingSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports